/* compoCASE – globale Anpassungen (Mobil-Update) */
(function () {
  function headerBottom() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    return Math.max(0, h.getBoundingClientRect().bottom);
  }

  /* Gravur-Seite: Vorschau sitzt direkt unter dem Header. Beim Scrollen wird sie am Handy
     kompakter und rückt nach oben, damit unten maximal Platz für die Gravur-Optionen bleibt. */
  function stickyPreview() {
    var pv = document.querySelector('.ccx-preview');
    var img = document.getElementById('ccx-img');
    if (!pv || !img) return;
    var root = document.getElementById('ccx');
    var ticking = false, full = 0, compact = false;
    var mq = window.matchMedia('(max-width: 749px)');
    function measure() {
      if (compact) return;
      full = img.getBoundingClientRect().height;
    }
    function setCompact(on) {
      if (on === compact) return;
      if (on) measure();
      compact = on;
      if (!mq.matches || !full) { root.classList.remove('ccx-compact'); pv.style.marginBottom = ''; img.style.maxHeight = ''; return; }
      var small = Math.round(Math.min(full, window.innerHeight * 0.3));
      root.classList.toggle('ccx-compact', on);
      img.style.maxHeight = on ? small + 'px' : full + 'px';
      pv.style.marginBottom = on ? (20 + full - small) + 'px' : '';
      if (!on) setTimeout(function () { if (!compact) img.style.maxHeight = ''; }, 300);
    }
    function update() {
      ticking = false;
      var top = Math.round(headerBottom() + (mq.matches ? 0 : 8));
      pv.style.top = top + 'px';
      var wrap = pv.parentElement.getBoundingClientRect().top;
      setCompact(mq.matches && wrap < top - 40);
    }
    var settle;
    function request() {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      clearTimeout(settle);
      settle = setTimeout(update, 350);
    }
    if (img.complete) measure(); else img.addEventListener('load', measure);
    update();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () { compact = false; img.style.maxHeight = ''; pv.style.marginBottom = ''; root.classList.remove('ccx-compact'); measure(); request(); });
  }

  /* Desktop: Menü öffnet beim Drüberfahren mit der Maus */
  function hoverMenu() {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    var items = document.querySelectorAll('.header__inline-menu details');
    items.forEach(function (d) {
      var timer;
      var summary = d.querySelector('summary');
      function open() {
        clearTimeout(timer);
        items.forEach(function (o) {
          if (o !== d && o.hasAttribute('open')) {
            o.removeAttribute('open');
            var s = o.querySelector('summary');
            if (s) s.setAttribute('aria-expanded', 'false');
          }
        });
        if (!d.hasAttribute('open')) {
          d.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      }
      function close() {
        timer = setTimeout(function () {
          d.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 200);
      }
      d.addEventListener('mouseenter', open);
      d.addEventListener('mouseleave', close);
      if (summary) {
        summary.addEventListener('click', function (e) {
          if (d.hasAttribute('open')) { e.preventDefault(); }
        });
      }
    });
  }


  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  /* Hüllen-Seite: Gravur-Button mit Preis-Hinweis, Modell und Farbe werden an den Konfigurator übergeben */
  function persLink() {
    var a = document.querySelector('.ccx-pers-bar a[href*="personalisierte-compocase"]');
    if (!a) return;
    var hint = document.createElement('p');
    hint.className = 'cc-pers-hint';
    hint.textContent = 'Mit Name oder Initialen · ab +5€';
    a.parentNode.insertBefore(hint, a);
    var handle = (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
    var model = handle.replace('-huelle', '').replace('-case-weizenstroh', '').replace(/-/g, '');
    a.addEventListener('click', function () {
      var q = ['model=' + encodeURIComponent(model)];
      var c = document.querySelector('input[type="radio"][name^="Farbe"]:checked');
      if (c) q.push('color=' + encodeURIComponent(c.value.toLowerCase().replace(/\s+/g, '')));
      var g = document.querySelector('input[type="radio"][name^="Ausf"]:checked');
      if (g) q.push('charge=' + encodeURIComponent(g.value.toLowerCase()));
      a.href = '/products/personalisierte-compocase?' + q.join('&');
    });
  }

  /* Gravur-Konfigurator: Modell, Farbe und Ausführung aus dem Link übernehmen */
  function preselect() {
    var list = document.getElementById('ccx-model-list');
    if (!list) return;
    var cp = new URLSearchParams(location.search);
    var cm = (cp.get('model') || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!cm) return;
    var cc = (cp.get('color') || '').toLowerCase().replace(/[^a-z]/g, '');
    var cg = (cp.get('charge') || '').toLowerCase().replace(/[^a-z]/g, '');
    var mb = list.querySelector('button[data-model="' + cm + '"]');
    if (!mb || mb.disabled || mb.classList.contains('unavailable')) return;
    mb.click();
    setTimeout(function () {
      if (cc) {
        var cb = document.querySelector('#ccx .ccx-color[data-color="' + cc + '"]');
        if (cb && !cb.disabled) cb.click();
      }
      if (cg) {
        var gb = document.querySelector('#ccx [data-charge="' + cg + '"]');
        if (gb && !gb.disabled) gb.click();
      }
    }, 300);
  }

  /* Handykette: Angebotsbox im gleichen Stil wie bei den Hüllen */
  function strapBox() {
    var old = document.getElementById('cc-duo-bundle');
    if (!old) return;
    var url = location.pathname.replace(/\/$/, '') + '.js';
    fetch(url).then(function (r) { return r.json(); }).then(function (p) {
      function idx(name) {
        return p.options.findIndex(function (o) { return String(o.name || o).toLowerCase() === name; });
      }
      var ti = idx('tragetyp'), ci = idx('farbe');
      if (ti < 0 || ci < 0) return;
      function minPrice(t) {
        var m = null;
        p.variants.forEach(function (v) {
          if (String(v.options[ti]).toUpperCase() === t && (m === null || v.price < m)) m = v.price;
        });
        return m;
      }
      var s = minPrice('SHORT'), l = minPrice('LONG'), duo = 2490;
      if (s === null || l === null) return;
      var save = s + l - duo;
      var box = document.createElement('div');
      box.className = 'bundle-box';
      box.id = 'cc-strap';
      box.innerHTML =
        '<p class="bundle-title">Wähle deine compoSTRAP</p>' +
        '<button type="button" class="bundle-option" data-type="SHORT"><span class="bundle-radio"></span><span class="bundle-label">SHORT<small>Fürs Handgelenk oder als Schlüsselanhänger</small></span><span class="bundle-price">' + money(s) + '</span></button>' +
        '<button type="button" class="bundle-option" data-type="LONG"><span class="bundle-radio"></span><span class="bundle-label">LONG<small>Über der Schulter, Hände frei</small></span><span class="bundle-price">' + money(l) + '</span></button>' +
        '<button type="button" class="bundle-option" data-type="DUO"><span class="bundle-radio"></span><span class="bundle-label">SHORT + LONG<em>Set</em><small>' + (save > 0 ? 'Spare ' + money(save) + ' · ' : '') + 'Farben frei kombinierbar</small></span><span class="bundle-price">' + money(duo) + '</span></button>' +
        '<p class="bundle-note">Der Set-Preis wird automatisch im Warenkorb berechnet.</p>';
      old.parentNode.insertBefore(box, old);
      document.body.classList.add('cc-strap-ready');

      /* Set: SHORT und LONG jeweils in eigener Farbe (Rabatt gilt farbunabhängig) */
      var cols = [];
      p.variants.forEach(function (v) { if (cols.indexOf(v.options[ci]) < 0) cols.push(v.options[ci]); });
      var pickCol = { SHORT: null, LONG: null };
      function swatchFor(c) {
        var inp = [].slice.call(document.querySelectorAll('variant-selects input[name^="Farbe"]')).filter(function (i) { return i.value === c; })[0];
        var lab = inp && (document.querySelector('label[for="' + inp.id + '"]') || inp.nextElementSibling);
        var sw = lab && lab.querySelector('.swatch');
        return sw ? sw.outerHTML : '';
      }
      function avail(t, c) {
        return p.variants.some(function (v) { return v.options[ci] === c && String(v.options[ti]).toUpperCase() === t && v.available; });
      }
      function row(t) {
        return '<div class="cc-duo-colors__group" data-type="' + t + '">' +
          '<p class="cc-duo-colors__label"><span>' + t + '</span><strong class="cc-duo-name"></strong></p>' +
          '<div class="cc-duo-colors__list" role="radiogroup" aria-label="Farbe für ' + t + '">' +
          cols.map(function (c) {
            var sw = swatchFor(c);
            return '<button type="button" role="radio" class="cc-duo-color' + (sw ? '' : ' is-text') + '" data-color="' + c + '" title="' + c + '" aria-label="' + t + ' in ' + c + '" aria-checked="false"' + (avail(t, c) ? '' : ' disabled') + '>' + (sw || c) + '</button>';
          }).join('') +
          '</div></div>';
      }
      var duoBox = document.createElement('div');
      duoBox.className = 'cc-duo-colors';
      duoBox.hidden = true;
      duoBox.innerHTML =
        '<style>' +
        '.cc-duo-colors{margin:-2px 0 12px;padding:16px;border:1px solid rgba(28,34,40,.12);border-radius:12px;background:#F9F7F2;color:#1C2228}' +
        '.cc-duo-colors[hidden]{display:none}' +
        '.cc-duo-colors.is-open{animation:ccDuoOpen .25s ease}' +
        '@keyframes ccDuoOpen{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:none}}' +
        '.cc-duo-colors__intro{margin:0 0 14px;font-size:14px;line-height:1.5;color:#6B7280}' +
        '.cc-duo-colors__group + .cc-duo-colors__group{margin-top:16px;padding-top:16px;border-top:1px solid rgba(28,34,40,.1)}' +
        '.cc-duo-colors__label{margin:0 0 10px;font-size:14px;line-height:1.4}' +
        '.cc-duo-colors__label span{display:inline-block;min-width:58px;font-weight:600;letter-spacing:.04em}' +
        '.cc-duo-colors__label strong{font-weight:400}' +
        '.cc-duo-colors__list{display:flex;flex-wrap:wrap;gap:8px}' +
        '.cc-duo-color{width:38px;height:38px;border-radius:50%;border:1px solid rgba(28,34,40,.2);padding:3px;background:#fff;cursor:pointer;display:inline-flex;align-items:center;justify-content:center;transition:border-color .2s ease}' +
        '.cc-duo-color .swatch{display:block;width:100%;height:100%;border-radius:50%;margin:0;--swatch-input--size:100%}' +
        '.cc-duo-color[aria-checked="true"]{border:2px solid #1C2228;padding:2px}' +
        '.cc-duo-color:disabled{opacity:.35;cursor:not-allowed}' +
        '.cc-duo-color.is-text{width:auto;border-radius:999px;padding:0 12px;font-size:13px}' +
        '.cc-duo-color.is-text[aria-checked="true"]{padding:0 11px}' +
        '.cc-duo-color:focus-visible{outline:2px solid #1C2228;outline-offset:2px}' +
        '</style>' +
        '<p class="cc-duo-colors__intro">Wähle für SHORT und LONG jeweils deine Farbe. Gleich oder unterschiedlich, wie du magst.</p>' +
        row('SHORT') + row('LONG');
      box.insertBefore(duoBox, box.querySelector('.bundle-note'));
      function curCol() {
        var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var cur = p.variants.find(function (v) { return String(v.id) === String(idEl && idEl.value); });
        if (cur) return cur.options[ci];
        var r = document.querySelector('variant-selects input[name^="Farbe"]:checked');
        return r ? r.value : cols[0];
      }
      function colFor(t) {
        var c = pickCol[t] || curCol();
        if (!avail(t, c)) c = cols.filter(function (x) { return avail(t, x); })[0] || c;
        return c;
      }
      function renderDuo() {
        ['SHORT', 'LONG'].forEach(function (t) {
          var g = duoBox.querySelector('.cc-duo-colors__group[data-type="' + t + '"]');
          var c = colFor(t);
          g.querySelector('.cc-duo-name').textContent = c || '';
          g.querySelectorAll('.cc-duo-color').forEach(function (b) {
            b.setAttribute('aria-checked', b.getAttribute('data-color') === c ? 'true' : 'false');
          });
        });
      }
      duoBox.addEventListener('click', function (e) {
        var b = e.target.closest('.cc-duo-color');
        if (!b || b.disabled) return;
        var t = b.closest('.cc-duo-colors__group').getAttribute('data-type');
        pickCol[t] = b.getAttribute('data-color');
        renderDuo();
        /* Bild oben zeigt die Farbe, die zuletzt gewählt wurde */
        var r = [].slice.call(document.querySelectorAll('variant-selects input[name^="Farbe"]')).filter(function (i) { return i.value === pickCol[t]; })[0];
        if (r && !r.checked) r.click();
      });

      var isDuo = false;
      function radios() {
        return [].slice.call(document.querySelectorAll('input[type="radio"][name^="Tragetyp"]'));
      }
      function mark(t) {
        box.querySelectorAll('.bundle-option').forEach(function (x) {
          x.classList.toggle('is-active', x.getAttribute('data-type') === t);
        });
      }
      function sync() {
        if (isDuo) return;
        var r = radios().filter(function (i) { return i.checked; })[0];
        if (r) mark(String(r.value).toUpperCase());
      }
      box.addEventListener('click', function (e) {
        var o = e.target.closest('.bundle-option');
        if (!o) return;
        var t = o.getAttribute('data-type');
        isDuo = t === 'DUO';
        if (!isDuo) {
          var r = radios().filter(function (i) { return String(i.value).toUpperCase() === t; })[0];
          if (r && !r.checked) r.click();
        }
        mark(t);
        var wasHidden = duoBox.hidden;
        duoBox.hidden = !isDuo;
        if (isDuo) {
          if (!pickCol.SHORT) pickCol.SHORT = colFor('SHORT');
          if (!pickCol.LONG) pickCol.LONG = colFor('LONG');
          renderDuo();
          if (wasHidden) { duoBox.classList.remove('is-open'); void duoBox.offsetWidth; duoBox.classList.add('is-open'); }
        }
      });
      document.addEventListener('change', function (e) {
        if (e.target && e.target.name && e.target.name.indexOf('Tragetyp') === 0) sync();
      });
      sync();

      document.addEventListener('submit', function (e) {
        if (!isDuo) return;
        var f = e.target;
        if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var idEl = f.querySelector('[name="id"]');
        var cur = p.variants.find(function (v) { return String(v.id) === String(idEl && idEl.value); });
        var col = cur ? cur.options[ci] : null;
        function pick(t) {
          return p.variants.find(function (v) {
            return v.options[ci] === col && String(v.options[ti]).toUpperCase() === t && v.available;
          });
        }
        function pickIn(t) {
          var c = colFor(t);
          return p.variants.find(function (v) {
            return v.options[ci] === c && String(v.options[ti]).toUpperCase() === t && v.available;
          });
        }
        var sv = pickIn('SHORT'), lv = pickIn('LONG');
        if (!sv || !lv) {
          alert('Diese Farbkombination ist gerade nicht verfügbar. Bitte wähle eine andere Farbe.');
          return;
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: sv.id, quantity: 1 }, { id: lv.id, quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart');
          location.href = '/cart';
        }).catch(function () {
          alert('Das Set konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
        });
      }, true);
    }).catch(function () {});
  }


  /* Produktseiten: Reiter (Technische Daten, Lieferumfang, Versand & Rückgabe).
     Überall untereinander, öffnen sich beim Anklicken. */
  var CC_ROW = function (rows) {
    return '<table class="cc-spec">' + rows.map(function (r) {
      return '<tr><th>' + r[0] + '</th><td>' + r[1] + '</td></tr>';
    }).join('') + '</table>';
  };
  function CC_SHIP(isCase) {
    return CC_ROW([
      ['Versand', 'Deutschland 4,90€, kostenlos ab 39,90€'],
      ['Lieferzeit', '3–5 Werktage mit DHL Eco'],
      ['EU & Schweiz', 'ab 7,90€, <a href="/policies/shipping-policy">alle Versandkosten</a>'],
      ['Verpackung', 'plastikfrei'],
      ['Rückgabe', '14 Tage Widerrufsrecht' + (isCase ? ', gravierte Hüllen ausgenommen' : '') + '. <a href="/policies/refund-policy">Widerrufsbelehrung</a>']
    ]);
  }
  var CC_SHIP_GRAVUR = CC_ROW([
    ['Versand', 'Deutschland 4,90€, kostenlos ab 39,90€'],
    ['Lieferzeit', '5–8 Werktage inkl. Gravur, Versand mit DHL Eco'],
    ['EU & Schweiz', 'ab 7,90€, <a href="/policies/shipping-policy">alle Versandkosten</a>'],
    ['Verpackung', 'plastikfrei'],
    ['Rückgabe', 'Gravierte Hüllen werden für dich gefertigt und sind vom Widerrufsrecht ausgeschlossen. Bei Mängeln gilt die gesetzliche Gewährleistung. <a href="/policies/refund-policy">Widerrufsbelehrung</a>']
  ]);
  var CC_TRIPLE = CC_ROW([
    ['Laden', 'kabellos für drei Geräte gleichzeitig'],
    ['Smartphone', 'bis 15 W (iPhone: bis 7,5 W)'],
    ['Smartwatch', 'Apple Watch, bis 2,5 W'],
    ['Kopfhörer', 'kabellos ladbare Earbuds (z. B. AirPods), bis 3 W'],
    ['Eingang', '9 V / 2 A über USB-C'],
    ['Kabel', 'USB-C-Kabel inklusive'],
    ['Holz', 'Bambus'],
    ['Netzteil', 'nicht enthalten, empfohlen: Schnellladenetzteil ab 18 W (Quick Charge 3.0 oder USB-C PD)'],
    ['Mit compoCASE', 'lädt durch die Hülle'],
    ['Konformität', 'CE, RoHS']
  ]);
  var CC_STRAP = CC_ROW([
    ['Material', 'Baumwolle und Nylon'],
    ['Länge SHORT', '20–30 cm'],
    ['Länge LONG', '120–160 cm'],
    ['Verbindung', 'Metallplättchen für deine compoCASE, inklusive']
  ]);
  var CC_CASE = CC_ROW([
    ['Material', 'Weizenstrohfasern und TPU'],
    ['Stärke', 'ca. 2 mm'],
    ['Kameraschutz', 'ca. 4 mm erhöhter Rand'],
    ['Schutz', '360° Rundumschutz'],
    ['Oberfläche', 'matt, Soft-Touch'],
    ['Laden', 'Wireless Charging kompatibel'],
    ['Kompostierbarkeit', 'industriell kompostierbar, DIN EN 13432 zertifiziert'],
    ['Verpackung', 'plastikfrei']
  ]);

  function productTabs() {
    var ccx = document.getElementById('ccx');
    var info = ccx ? ccx.querySelector('.ccx-config') : document.querySelector('.product__info-container');
    if (!info || document.getElementById('cc-tabs')) return;
    var handle = (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
    var tabs = [];
    var oldDetails = [].slice.call(info.querySelectorAll('details')).filter(function (d) {
      var s = d.querySelector('summary');
      return s && /Technische Daten/i.test(s.textContent);
    });
    var isCharger = /charger/.test(handle);
    var isStrap = /handykette|strap/.test(handle);
    if (oldDetails.length) {
      var t = oldDetails[0].querySelector('table');
      tabs.push(['Technische Daten', t ? CC_ROW([].slice.call(t.querySelectorAll('tr')).map(function (tr) {
        var c = tr.querySelectorAll('td');
        return [c[0] ? c[0].innerHTML : '', c[1] ? c[1].innerHTML : ''];
      })) : oldDetails[0].innerHTML]);
      oldDetails.forEach(function (d) { d.remove(); });
    } else if (/triple|3in1/.test(handle)) {
      tabs.push(['Technische Daten', CC_TRIPLE]);
    } else if (isStrap) {
      tabs.push(['Technische Daten', CC_STRAP]);
    } else if (!isCharger) {
      tabs.push(['Technische Daten', CC_CASE]);
    }
    if (isCharger) tabs.push(['Lieferumfang', '<ul class="cc-list"><li>Wood Wireless Charger</li><li>USB-C-Kabel</li><li>Bewusst ohne Netzteil, nutze eines, das du schon hast</li></ul>']);
    else if (isStrap) tabs.push(['Lieferumfang', '<ul class="cc-list"><li>compoSTRAP in deiner Farbe und Länge</li><li>Metallplättchen zur Verbindung mit deiner compoCASE</li></ul>']);
    else if (ccx) tabs.push(['Lieferumfang', '<ul class="cc-list"><li>compoCASE für dein Modell mit deiner Gravur</li><li>Plastikfreie Verpackung</li></ul>']);
    else tabs.push(['Lieferumfang', '<ul class="cc-list"><li>compoCASE für dein Modell</li><li>Plastikfreie Verpackung</li></ul>']);
    tabs.push(['Versand & Rückgabe', ccx ? CC_SHIP_GRAVUR : CC_SHIP(!isCharger && !isStrap)]);

    var box = document.createElement('div');
    box.className = 'cc-tabs';
    box.id = 'cc-tabs';
    var bar = '<div class="cc-tabs__bar" role="tablist">';
    var panels = '';
    tabs.forEach(function (t, i) {
      bar += '<button type="button" role="tab" class="cc-tabs__tab" id="cc-tab-' + i + '" aria-controls="cc-panel-' + i + '" aria-selected="false">' + t[0] + '</button>';
      panels += '<div class="cc-tabs__item"><button type="button" class="cc-tabs__acc" aria-expanded="false" aria-controls="cc-panel-' + i + '">' + t[0] + '<span class="cc-tabs__icon" aria-hidden="true"></span></button>' +
        '<div class="cc-tabs__panel" id="cc-panel-' + i + '" role="tabpanel" aria-labelledby="cc-tab-' + i + '"><div class="cc-tabs__inner">' + t[1] + '</div></div></div>';
    });
    bar += '</div>';
    box.innerHTML = bar + '<div class="cc-tabs__panels">' + panels + '</div>';

    var anchor = ccx ? info.querySelector('.ccx-head') : info.querySelector('.product__description') || info.querySelector('.cc-pay') || info.querySelector('product-form, .product-form');
    if (anchor) {
      var blockEl = ccx ? anchor : (anchor.closest('.product__info-container > *') || anchor);
      blockEl.parentNode.insertBefore(box, blockEl.nextSibling);
    } else {
      info.appendChild(box);
    }

    var desk = window.matchMedia('(min-width: 750px)');
    var tabBtns = [].slice.call(box.querySelectorAll('.cc-tabs__tab'));
    var accBtns = [].slice.call(box.querySelectorAll('.cc-tabs__acc'));
    var items = [].slice.call(box.querySelectorAll('.cc-tabs__item'));
    function select(i) {
      items.forEach(function (it, k) { it.classList.toggle('is-open', k === i); accBtns[k].setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      tabBtns.forEach(function (b, k) { b.classList.toggle('is-active', k === i); b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function mode() { /* überall untereinander, geschlossen bis zum Anklicken */ }
    tabBtns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
    accBtns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var open = items[i].classList.contains('is-open');
        items[i].classList.toggle('is-open', !open);
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
    if (desk.addEventListener) desk.addEventListener('change', mode);
    mode();
  }

  /* Kleinunternehmer (§ 19 UStG): kein „Inkl. Steuern“ anzeigen */
  function noTax() {
    var re = /Inkl\.\s*Steuern[.,]?\s*/i;
    var nodes = document.querySelectorAll('.product__tax, .ccx-shipping-info, .tax-note, .totals__tax, .cart__footer small, .cart-drawer small');
    nodes.forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var n, done = false;
      while ((n = w.nextNode())) {
        if (re.test(n.nodeValue)) {
          var isCart = /Rabatte|Versand.*Checkout/i.test(el.textContent);
          n.nodeValue = n.nodeValue.replace(re, isCart ? '' : 'Umsatzsteuerfrei nach § 19 UStG. ');
          done = true;
        }
      }
      if (done && el.textContent.trim() === '') el.style.display = 'none';
    });
  }
  function gravurNote() {
    var n = document.querySelector('#ccx .ccx-ship-note');
    if (n) n.textContent = 'Lieferzeit inkl. Gravur: 5–8 Werktage mit DHL Eco.';
  }
  function watchTax() {
    noTax();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(noTax, 80); })
      .observe(document.body, { childList: true, subtree: true });
  }

  /* Hüllen-Angebotsbox: Preise passen sich der gewählten Ausführung (Standard / MagSafe) an */
  function bundlePrices() {
    var box = document.getElementById('cc-bundle');
    if (!box) return;
    var url = location.pathname.replace(/\/$/, '') + '.js';
    fetch(url).then(function (r) { return r.json(); }).then(function (p) {
      /* Mengenrabatt (Shopify-Rabatte Bundle2/Bundle3): 2 Hüllen = 10 %, 3 Hüllen = 20 % */
      var PCT = { 1: 0, 2: 10, 3: 20 };
      function saveFor(price, q) {
        if (q === 2) return Math.round(price * 0.2);
        if (q === 3) return 2 * Math.round(price * 0.3);
        return 0;
      }
      function current() {
        var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var v = idEl && p.variants.find(function (x) { return String(x.id) === String(idEl.value); });
        return v || p.variants[0];
      }
      function render() {
        var price = current().price;
        var b = document.getElementById('cc-bundle');
        if (!b) return;
        b.querySelectorAll('.bundle-option').forEach(function (o) {
          var q = parseInt(o.getAttribute('data-qty'), 10) || 1;
          var pr = o.querySelector('.bundle-price');
          if (pr) pr.textContent = money(price * q - saveFor(price, q));
          var sm = o.querySelector('.bundle-label small');
          if (sm && PCT[q]) sm.textContent = 'Spare ' + PCT[q] + ' % · versandkostenfrei in DE';
        });
      }
      render();
      function later() { setTimeout(render, 80); setTimeout(render, 700); }
      document.addEventListener('change', later);
      document.addEventListener('variant:change', later);
    }).catch(function () {});
  }

  function init() { stickyPreview(); hoverMenu(); persLink(); preselect(); strapBox(); productTabs(); bundlePrices(); gravurNote(); watchTax(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
